export const cobrowseProducts = ["helloscreen", "userview", "cobrowsingapi"] as const;

export const cobrowsePrefixes = {
  helloscreen: "hs",
  userview: "uv",
  cobrowsingapi: "co",
} as const;
